import React, { useState } from 'react';
import { Box, Button, Modal, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';

interface YoutubePlaylistModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (playlistId: string | null) => void;
  submitting?: boolean
}

const YoutubePlaylistModal: React.FC<YoutubePlaylistModalProps> = ({ open, onClose, onSubmit, submitting }) => {
  const [playlistUrl, setPlaylistUrl] = useState('');

  const handleSubmit = () => {
    const url = new URL(playlistUrl);
    url.searchParams.get('list');
    onSubmit(url.searchParams.get('list'));
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" component="h2" gutterBottom>
          Input Youtube playlist URL
        </Typography>
        <TextField
          fullWidth
          label="Playlist URL"
          value={playlistUrl}
          onChange={(e) => setPlaylistUrl(e.target.value)}
          margin="normal"
        />
        <Box mt={2} display="flex" justifyContent="flex-end">
          <Button onClick={onClose} sx={{ mr: 1 }}>
            Cancel
          </Button>
          <LoadingButton variant="contained" onClick={handleSubmit} loading={submitting} disabled={!playlistUrl}>
            Submit
          </LoadingButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default YoutubePlaylistModal;